import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  () => ({
    root: {
      top: '170px',
      right: '0',
      bottom: '0',
      position: 'fixed',
      background: '#000',
      opacity: '0',
      zIndex: '9999',
      overflow: 'scroll',
      width: 360,
      height: 'calc(100vh - 170px)',
      '& > div': {
        height: 9999,
      },
    },
  }),
  { name: 'Mask' },
);

function Mask({ mainId }) {
  const classes = useStyles();
  const [contentNode, setContentNode] = useState(null);
  const contentRef = useCallback(node => {
    if (node !== null) {
      setContentNode(node);
    }
  }, []);
  const { isActive } = useSelector(store => store.ma);

  function handleScroll(id) {
    const $main = document.getElementById(id);
    if ($main) {
      const { scrollTop } = contentNode;
      const { scrollHeight } = $main;
      if (scrollHeight + 114 < scrollTop) {
        contentNode.scrollTop = scrollHeight + 170;
        return;
      }

      $main.scrollTop = scrollTop - 85;
    }
  }

  useEffect(() => {
    if (contentNode) {
      contentNode.removeEventListener('scroll', () => handleScroll(mainId));
      contentNode.addEventListener('scroll', () => handleScroll(mainId));
      return () => {
        contentNode.removeEventListener('scroll', () => handleScroll(mainId));
      };
    }
    return () => {};
  }, [mainId, contentNode]);

  if (isActive) {
    return (
      <div ref={contentRef} className={classes.root}>
        <div />
      </div>
    );
  }
  return null;
}

export default Mask;
